"use client";

import Icon from "@/components/icons/Icons";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function AnimatedFakeChart() {
  const [showGradient, setShowGradient] = useState(false);
  const [showTag, setShowTag] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowGradient(true);
      setShowTag(true);
    }, 2000);
  });

  return (
    <>
      <div className="flex items-center gap-2 py-3 px-4.5 border-b border-gray-100">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.65234 1.6543V10.4748C1.65234 10.7672 1.76851 11.0477 1.97528 11.2544C2.18205 11.4612 2.46249 11.5774 2.75491 11.5774H11.5754"
            stroke="#00BC7D"
            strokeWidth="1.10256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.92188 9.37217V4.96191"
            stroke="#00BC7D"
            strokeWidth="1.10256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.16797 9.37222V2.75684"
            stroke="#00BC7D"
            strokeWidth="1.10256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41016 9.37211V7.71826"
            stroke="#00BC7D"
            strokeWidth="1.10256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <span className="text-xs font-semibold text-[#6A7282] uppercase tracking-[0.7px]">Strategy Map</span>

        <span className="text-xs font-bold text-[#009966] ml-auto">+12.4%</span>
      </div>

      <svg
        width="290"
        height="160"
        viewBox="0 0 288 160" // ✅ FIXED
        fill="none"
        className="w-64 sm:w-full absolute top-[31%] inset-x-0"
      >
        <defs>
          <linearGradient
            id="areaGradient"
            x1="0"
            y1="0"
            x2="0"
            y2="160" // ✅ match height
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#10B981" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#10B981" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* AREA */}
        {showGradient && (
          <motion.path
            d="M1.65421 100.885 C48.5349 89.8592 95.4156 84.3464 142.296 78.8336 C177.457 45.7567 212.617 12.6798 282.938 1.65411 L282.938 160 L1.65421 160 Z"
            fill="url(#areaGradient)"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 2,
              ease: "easeInOut",
            }}
          />
        )}

        <path
          d="M1.65421 100.885 C48.5349 89.8592 95.4156 84.3464 142.296 78.8336 L290 55"
          stroke="#D1D5DC"
          strokeWidth="2.2"
          strokeDasharray="4.41 4.41"
          fill="none"
        />
        {/* LINE */}
        <motion.path
          d="M1.65421 100.885C48.5349 89.8592 95.4156 84.3464 142.296 78.8336C177.457 45.7567 212.617 12.6798 282.938 1.65411"
          stroke="#10B981"
          strokeWidth="3"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 2,
            ease: "easeInOut",
          }}
        />
      </svg>

      {showTag && (
        <>
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-3 h-3 absolute inset-x-0 bottom-[24%] sm:bottom-[28%] mx-auto rounded-full border-2 border-[#00BC7D] bg-white"
          />

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="absolute z-1 -right-5 bottom-[-10%] bg-white border border-[#D0FAE5] rounded-xl shadow-[0px_9.44px_11.8px_-7.08px_#0000001A,0px_23.6px_29.5px_-5.9px_#0000001A] px-2 sm:px-3 py-1.5 sm:py-2 text-[11px] font-semibold text-[#364153] flex items-center gap-2"
          >
            <span className="rounded-xs p-1 bg-emerald-50">
              <Icon.growthSVG className="w-4 h-4 text-[#00BC7D]" />
            </span>

            <div>
              <p className="text-[9px] font-medium text-[#99A1AF] tracking-[0.6px] uppercase">Projected</p>
              <p className="text-xs font-bold text-[#364153]">Goal On Track</p>
            </div>
          </motion.div>
        </>
      )}
    </>
  );
}
